4<template>
  <b-modal
    v-model="modal"
    :title="title"
    size="lg"
    :no-enforce-focus="false"
    :no-close-on-backdrop="true"
  >
    <loading
      :active.sync="loading"
      color="#556ee6"
      loader="dots"
      :can-cancel="false"
      :is-full-page="false">
    </loading>
    <div class="row">
      <div class="col-lg-12">
        <b-card-body>
          <form autocomplete="off">
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="hotel_id">Hotel *</label>
                  <select
                    id="hotel_id"
                    v-model="filter.hotel_id"
                    name="hotel_id"
                    class="form-control"
                    @change="setHotel(filter.hotel_id)"
                    :class="{
                      'is-invalid': submitted && $v.filter.hotel_id.$error
                    }"
                  >
                    <option value="null" disabled>Selecione um Hotel</option>
                    <option v-for="item in hotels" :key="item.id" :value="item.id">{{ item.name }}</option>
                  </select>
                  <div
                    v-if="submitted && !$v.filter.hotel_id.required"
                    class="invalid-feedback"
                  >
                    O campo é obrigatório.
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="name">Categoria *</label>
                  <select
                    id="name"
                    v-model="filter.category_id"
                    name="name"
                    placeholder="Ex: Basic, Deluxe, etc"
                    @change="getTypesAccommodations()"
                    class="form-control"
                    :class="{
                      'is-invalid': submitted && $v.filter.category_id.$error
                    }"
                  >
                    <option value="null" disabled>Selecione uma categoria</option>
                    <option v-for="item in categories" :key="item.id" :value="item.id">{{ item.name }}</option>
                  </select>
                  <div
                    v-if="submitted && !$v.filter.category_id.required"
                    class="invalid-feedback"
                  >
                    O campo é obrigatório.
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="mb-4" v-if="hotelSelected.id">
                  <div class="d-flex align-items-center gap-1 items-center mb-2">
                    <i class="bx bxs-info-circle text-primary font-size-16"></i>
                    <span class="text-muted">Capacidade: {{ hotelSelected.allocatedRooms }}/{{ hotelSelected.capacity }} ocupados</span>
                  </div>
                  <b-progress :max="hotelSelected.capacity" height="4px" variant="primary" size="sm">
                    <b-progress-bar :value="hotelSelected.allocatedRooms">
                    </b-progress-bar>
                  </b-progress>
                </div>
              </div>
            </div>
            <div class="row" v-if="hotelSelected.id">
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="hotel_date_range_id">Range de datas *</label>
                  <select
                    id="hotel_date_range_id"
                    v-model="filter.hotel_date_range_id"
                    name="hotel_date_range_id"
                    class="form-control"
                    :class="{
                      'is-invalid': submitted && $v.filter.hotel_date_range_id.$error
                    }"
                  >
                    <option :value="null" disabled>Selecione o período</option>
                    <option v-for="range in dateRanges" :key="range.id" :value="range.id">
                      {{ $moment(range.check_in).format('DD/MM/YYYY') }} até {{ $moment(range.check_out).format('DD/MM/YYYY') }}
                    </option>
                  </select>
                  <div
                    v-if="submitted && !$v.filter.hotel_date_range_id.required"
                    class="invalid-feedback"
                  >
                    O campo é obrigatório.
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="description"><i class="mdi mdi-filter mr-1 font-size-16 text-primary"></i> Filtro de participantes</label>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label for="gender">Gênero</label>
                  <select
                    id="gender"
                    v-model="filter.gender"
                    @change="updateFilterParticipant()"
                    class="form-control"
                  >
                    <option value="">Qualquer</option>
                    <option value="Feminino">Feminino</option>
                    <option value="Masculino">Masculino</option>
                  </select>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label for="age_init">Faixa etária</label>
                  <div class="d-flex align-items-center gap-1 items-center mb-2">
                    <input
                      id="age_init"
                      v-model="filter.age_init"
                      type="number"
                      min="1"
                      placeholder="Mín"
                      @change="updateFilterParticipant()"
                      maxlength="2"
                      class="form-control"
                    >
                    <input
                      id="age_end"
                      v-model="filter.age_end"
                      type="number"
                      @change="updateFilterParticipant()"
                      min="1"
                      maxlength="2"
                      placeholder="Máx"
                      class="form-control"
                    >
                  </div>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label for="group_id">Grupo</label>
                  <select
                    id="group_id"
                    v-model="filter.group_id"
                    @change="updateFilterParticipant()"
                    type="text"
                    class="form-control"
                  >
                    <option value="">Qualquer</option>
                    <option v-for="item in groups" :key="item.id" :value="item.id">{{ item.name }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row" v-if="filter.hotel_id && filter.category_id">
              <div class="col-sm-12">
                <div
                  class="alert alert-info fade show"
                  :class="{ 'alert-warning': !participants.length }"
                  role="alert">
                  <strong>{{ participants.length }}</strong> combinações encontradas
                </div>
              </div>
            </div>
            <!-- <div class="row" v-else>
              <div class="col-sm-12">
                <div class="alert alert-warning fade show" role="alert">Nenhum participante encontrado com os filtros selecionados</div>
              </div>
            </div> -->
            <div class="row mt-2" v-if="typeAccomodations.length && participants.length">
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="description"><i class="mdi mdi-bed mr-1 font-size-16 text-primary"></i> Acomodações disponíveis</label>
                </div>
                <div
                    v-if="submitted && !$v.filter.id_type_accommodation.required"
                    class="invalid-feedback"
                  >
                    Selecione um tipo de acomodação
                  </div>
              </div>
              <div class="col-sm-12">
                <div class="row mt-2">
                  <div class="col-sm-6" v-for="(ta, i) in typeAccomodations" :key="i">
                    <div class="item-mb-3 w-100 position-relative">
                      <label class="card-radio-label">
                        <input
                          type="radio"
                          class="card-radio-input"
                          :value="ta.id"
                          name="room_id"
                          :id="ta.id"
                          v-model="filter.id_type_accommodation"
                          :disabled="!ta.roomAvailable"
                          @change="setAccommodation(ta.id)"
                        />
                        <div class="card-radio position-relative" :class="{ 'room-occuped': !ta.roomAvailable }">
                          <div class="d-flex align-items-center">
                            <div class="btn btn-info btn-sm bg-opacity-70">
                              <i class="mdi-bed mdi font-size-20"></i>
                            </div>
                            <div class="d-flex flex-column ml-2">
                              <div class="texts-box">
                                <span class="text-1">{{ ta.type_room }}</span>
                                <span class="text-muted text-normal">{{ ta.capacity }} participante{{ ta.capacity > 1 ? 's' : '' }} por quarto</span>
                              </div>
                            </div>
                          </div>
                          <div class="texts-box mt-2">
                            <span class="text-2">Disponível: {{ ta.roomAvailable }} quartos</span>
                          </div>
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-4" v-if="accommodationSelected && accommodationSelected.id">
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="description"><i class="mdi mdi-chart-pie mr-1 font-size-16 text-primary"></i> Pré-visualização da alocação</label>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="table-responsive">
                  <table class="table">
                    <tbody>
                      <tr>
                        <td scope="col">Capacidade por quarto</td>
                        <th scope="col" class="text-right">{{ accommodationSelected.capacity }}</th>
                      </tr>
                      <tr>
                        <td scope="row">Quartos disponíveis</td>
                        <th class="text-right">{{ accommodationSelected.roomAvailable }}</th>
                      </tr>
                      <tr>
                        <td scope="row">Combinações encontradas</td>
                        <th class="text-right">{{ participants.length }}</th>
                      </tr>
                      <tr>
                        <td scope="row">Restantes</td>
                        <th class="text-right">{{ restAllocations }}</th>
                      </tr>
                      <tr>
                        <td scope="row">Taxa de alocação</td>
                        <th class="text-right">{{ allocationTax }}%</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </form>
        </b-card-body>
      </div>
    </div>
    <template v-slot:modal-footer>
      <b-button variant="secondary" @click="close()">Cancelar</b-button>
      <button type="submit" class="btn btn-primary mr-1" :disabled="user.role !== 'Admin' || !accommodationSelected.id || !participants.length" @click="saveAllocation()">Confirmar Alocação</button>
    </template>
  </b-modal>
</template>
<script>
// Import component
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapActions, mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import { EventBus } from '@/eventBus'

export default {
  components: {
    Loading
  },
  props: {},
  data () {
    return {
      title: 'Alocação em massa',
      loading: true,
      participants: [],
      hotelSelected: {},
      accommodationSelected: {
        id: null,
        capacity: 0,
        allocations: 0,
        allocation: []
      },
      typeAccomodations: [],
      rooms: [],
      categories: [],
      fullPage: true,
      submitted: false,
      beds: [
        {
          value: 'single',
          label: 'Single',
          capacity: 1,
          svg: 1
        },
        {
          value: 'duplo-casal',
          label: 'Duplo Cama Casal',
          capacity: 2,
          svg: 1
        },
        {
          value: 'double-twin',
          label: 'Duplo Twin',
          capacity: 2,
          svg: 2
        },
        {
          value: 'triple-twin',
          label: 'Triplo Twin',
          capacity: 3,
          svg: 3
        },
        {
          value: 'quadruple-twin',
          label: 'Quádruplo Twin',
          capacity: 4,
          svg: 4
        }
      ],
      filter: {
        hotel_id: null,
        hotel_date_range_id: null,
        category_id: null,
        gender: '',
        age_init: null,
        age_end: null,
        group_id: ''
      },
      dateRanges: [],
      modal: false,
      modalForm: false
    }
  },
  validations: {
    filter: {
      hotel_id: { required },
      hotel_date_range_id: { required },
      category_id: { required },
      id_type_accommodation: { required }
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions('room', {
      getRooms: 'getListRooms'
    }),
    ...mapActions('hotel', {
      getHotels: 'getAll'
    }),
    ...mapActions('hotelAccommodation', {
      typesAccommodations: 'getTypeAccomodations'
    }),
    ...mapActions('hotelAllocation', {
      getAllocation: 'getAllocation',
      postAllData: 'saveAll'
    }),
    ...mapActions('hotelCategory', {
      getAll: 'getAll'
    }),
    ...mapActions('group', {
      getAllGroups: 'getAll'
    }),
    ...mapActions('participant', {
      participantsMatchFiltered: 'getNotAllocated'
    }),
    setAccommodation (accommodationId) {
      let accommodationSelected = this.typeAccomodations.find(r => r.id === accommodationId)
      if (accommodationSelected) {
        this.accommodationSelected = { ...accommodationSelected }
        this.accommodationSelected.allocation = accommodationSelected.allocation?.data ?? []
      } else {
        this.accommodationSelected = null
      }
    },
    getGroups () {
      let params = {
        search: this.search || null,
        status: 1,
        limit: 100,
        page: 1
      }
      this.params = params
      this.getAllGroups(this.params).then((res) => {
      }).catch(error => {
        console.log(error)
      })
    },
    listRooms () {
      let params = {
        hotel_id: this.hotelSelected.id || null,
        category_id: this.filter.category_id || null,
        limit: 50,
        include: 'allocation.participant'
      }
      this.getRooms(params).then((res) => {
        this.rooms = res.data
      }).catch(error => {
        console.log(error)
      })
    },
    updateFilterParticipant () {
      let params = {
        gender: this.filter.gender || null,
        age_init: this.filter.age_init || null,
        age_end: this.filter.age_end || null,
        group_id: this.filter.group_id ? [this.filter.group_id] : null || null
      }
      this.participantsMatchFiltered(params).then((res) => {
        this.participants = res.data
      }).catch(error => {
        console.log(error)
      })
    },
    getTypesAccommodations () {
      this.accommodationSelected = {
        id: null,
        capacity: 0,
        allocations: 0,
        allocation: []
      }
      this.filter.id_type_accommodation = null
      let params = {
        hotel_id: this.hotelSelected.id || null,
        category_id: this.filter.category_id || null
      }
      this.typesAccommodations(params).then((res) => {
        this.typeAccomodations = res.data
      }).catch(error => {
        console.log(error)
      })
    },
    setHotel (hotelId) {
      this.hotelSelected = this.hotels.filter(h => h.id === hotelId)[0]
      this.dateRanges = (this.hotelSelected && this.hotelSelected.date_ranges) ? this.hotelSelected.date_ranges : []
      this.filter.hotel_date_range_id = null
      if (this.hotelSelected) {
        this.getCategories()
        this.typeAccomodations = []
        this.accommodationSelected = {
          id: null,
          capacity: 0,
          allocations: 0,
          allocation: []
        }
      }
    },
    listHotels () {
      let params = {
        search: null,
        limit: 100,
        page: 1
      }
      this.getHotels(params).then((res) => {
      }).catch(error => {
        console.log(error)
      })
    },
    getCategories () {
      let params = {
        hotel_id: this.hotelSelected.id || null,
        search: null,
        limit: 100,
        page: 1
      }
      this.getAll(params).then((res) => {
        this.categories = res.data
      }).catch(error => {
        console.log(error)
      })
    },
    open (id = null) {
      this.modal = true
      this.loading = true
      this.getGroups()
      this.updateFilterParticipant()
      this.loading = false
    },
    async saveAllocation () {
      this.submitted = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        window.scroll(0, 0)
        return
      }
      this.loading = true
      this.filter.group_id = this.filter.group_id ? [this.filter.group_id] : null || null
      await this.postAllData(this.filter).then(res => {
        let message = 'Sucesso: Alocação em massa realizado com sucesso.'
        let delay = 2500
        successMessage(message, delay)
        this.close()
        this.$emit('allocaded')
        EventBus.$emit('allocationAdded', 1)
      }).catch((err) => {
        errorMessage('Alerta: ' + err.message)
        this.loading = false
      })
    },
    close () {
      this.modal = false
      this.filter = {}
      this.hotelSelected = {}
      this.accommodationSelected = {
        id: null,
        capacity: 0,
        allocations: 0,
        allocation: []
      }
      this.typeAccomodations = []
      this.categories = []
      this.$v.$reset()
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('event', ['setting']),
    ...mapState('hotelAllocation', { data: 'accommodation' }),
    ...mapState('hotel', ['hotels']),
    ...mapState('group', ['groups']),
    restAllocations () {
      const remaining = this.participants.length - (this.accommodationSelected.roomAvailable * this.accommodationSelected.capacity)
      return Math.max(0, remaining)
    },
    allocationTax () {
      const totalCapacity = this.accommodationSelected.roomAvailable * this.accommodationSelected.capacity
      const rate = (totalCapacity / this.participants.length) * 100
      return Math.min(100, rate.toFixed(2))
    }
  },
  watch: {
    modal () {
      if (!this.modal) {
        this.close()
      }
    }
  }
}
</script>
<style scoped>
.vld-overlay.is-full-page {
    z-index: 1051 !important;
}
.modal-header {
  background: #000 !important;
  color: #fff;
}
.item-row {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 10px;
}
.col-item-2 {
  flex: 1 1 0;
  max-width: 170px;
  min-width: 170px;
  display: flex;
  justify-content: flex-start;
  height: 44px;
}
.item-mb-3 {
  width: 100%;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.card-radio-label {
  display: block;
  width: 100%;
}
.card-radio {
  display: flex;
  flex-direction: column;
  justify-content: left;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 5px;
  background-color: #fff;
  position: relative;
}
.card-radio svg {
  margin-bottom: 2px;
}
.card-radio span {
  display: block;
}
.text-normal {
  font-weight: 400 !important;
  font-size: 12px !important;
}
.texts-box {
  .text-1 {
    font-size: 14px;
    color: #05162B;
  }
  .text-2 {
    font-size: 11px;
    font-weight: 400;
    color: #05162B87;
  }
}
.room-partial {
  background: #ff9800;
  width: 14px;
  height: 14px;
  font-weight: 500;
  font-size: 10px;
  border-radius: 50%;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
}
.room-occuped {
  border: 1px solid #ca6363 !important;
  background-color: #fff5f5;

}
.position-absolute {
  position: absolute;
}
.top-0 {
  top: 1px;
}
.end-0 {
  right: 1px;
}
.text-success {
  color: #16A34A !important;
}
.text-warning {
  color: #ff9800;
}
/* .text-blue {
  color: #0D6EFD;
}
.text-pink {
  color: #F51919;
} */
</style>
